import React, { useEffect, useState } from 'react';
import { Dialog } from '@material-ui/core';
import * as actions from '../store/actions';
import { useTypedSelector } from '../shared/hooks/useTypedSelector';
import KapinuaDialogTitle from '../components/KapinuaDialog/KapinuaDialogTitle';
import { useTranslation } from 'react-i18next';
import ChangeGraphicColorDialog from '../components/ChangeGraphicColorDialog/ChangeGraphicColorDialog';
import { useDispatch } from 'react-redux';
import { loadGraphics, loadGraphicsReset } from '../store/actions';
import { IIndexable } from '../components/GraphicsLibrary/GraphicDetail/GraphicDetail';
import SnackBarType from '../objects/app/snackbar';
import { saveGraphicSvgErrors } from '../shared/apiErrors/SaveGraphicSvgErrors';
import { loadGraphicSvgErrors } from '../shared/apiErrors/loadGraphicSvgErrors';

interface Props {
    customerId: number | null;
    guestId: number | null;
}

declare global {
    interface Window {
        openChangeGraphicColorDialog: any;
    }
}

export interface ISelectedSize {
    id: string | number;
    name: string;
    count: string | number;
}

const ChangeGraphicColorDialogContainer: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { customerId, guestId } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [onSuccessFceName, setOnSuccessFceName] = React.useState<
        null | string
    >(null);
    const [idGraphic, setIdGraphic] = useState(0);
    const [overwriteSelected, setOverwriteSelected] = useState(false);
    const idDesign = (window as IIndexable)[window.GET_ID_DESIGN_FCE_NAME]();

    const messages = {
        saveGraphicSuccess: t('Change in color saved successfully.'),
    };

    // const errors = saveGraphicSvgErrors(t);

    const { data: saveSvgData, success: saveSvgSuccess } = useTypedSelector(
        (state) => state.changeGraphicColor.saveGraphicSvg
    );

    useEffect(() => {
        window.openChangeGraphicColorDialog = (
            graphicId: number,
            onSUccessFceName: string
        ) => {
            setIsOpen(true);
            setIdGraphic(graphicId);
            setOnSuccessFceName(onSUccessFceName);
            dispatch(
                actions.loadGraphicSvg(
                    customerId,
                    guestId,
                    graphicId,
                    loadGraphicSvgErrors(t)
                )
            );
        };

        return () => {
            dispatch(actions.loadGraphicSvgReset());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (saveSvgSuccess) {
            if (onSuccessFceName) {
                (window as IIndexable)[onSuccessFceName](saveSvgData);
            }

            if (saveSvgData?.id !== idGraphic && overwriteSelected) {
                dispatch(
                    actions.addSnackbar(
                        t(
                            'Graphic was detected in other design and was saved as new graphic.'
                        ),
                        SnackBarType.WARNING,
                        false
                    )
                );
            }
            setOnSuccessFceName(null);
            dispatch(loadGraphicsReset());
            dispatch(loadGraphics);
            handleOnClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveSvgSuccess]);

    const handleOnClose = () => {
        setIsOpen(false);
        setOverwriteSelected(false);
    };

    const onSubmit = (svg: string, overwrite: boolean) => {
        setOverwriteSelected(overwrite);
        const idLang = (window as IIndexable)[
            window.GET_ID_LANGUAGE_FCE_NAME
        ]();

        dispatch(
            actions.saveGraphicSvg(
                customerId,
                guestId,
                idGraphic,
                idLang,
                idDesign,
                svg,
                messages,
                overwrite,
                saveGraphicSvgErrors(t)
            )
        );
    };

    return (
        <Dialog onClose={handleOnClose} open={isOpen}>
            <KapinuaDialogTitle
                handleOnClose={handleOnClose}
                backText={t('< Back to Designer')}
            >
                <>{t('Change graphic color')}</>
            </KapinuaDialogTitle>
            <ChangeGraphicColorDialog onSubmit={onSubmit} />
        </Dialog>
    );
};

export default ChangeGraphicColorDialogContainer;
